


















































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { Message, MessageBox } from "element-ui";
// import  {}
@Component({})
export default class CdCar extends Vue {
  public carList: Array<any> = [
    {
      carNo: null,
      customerId: 0,
      headUrl: null,
      mobile: null,
      todayConsumAmount: 0,
      userName: null
    }
  ];
  public carNo = null;
  //   初始化 表格行
  tableRowClassName({ row, rowIndex }: any) {
    if (rowIndex % 2 == 0) {
      return "warning-row second-class";
    } else {
      return "";
    }
  }
  //初始化函数
  mounted() {
    this.getListData();
  }

  //start 分页
  public total = 0;
  public currentPage = 1;
  public listParam = {
    pageIndex: 1,
    pageSize: 10,
    queryCondition: ""
  };
  // 获取列表 getListdata
  getListData() {
    axios.get("carlist", { params: this.listParam }).then(res => {
    //   console.log(res);
      if (res.data.errCode == 0) {
        this.carList = res.data.result;
        this.total = res.data.totalCount;
      }
    });
  }
  handleSizeChange(val: any) {
    // console.log(`size${val}`);
    this.listParam.pageSize = val;
    this.getListData();
  }

  //   只要分页发生改变  此函数就会被调用
  handleCurrentChange(val: any) {
    // console.log(`current${val}`);
    this.listParam.pageIndex = val;
    this.getListData();
    // this.total=10*10
  }
  handlePrev(val: any) {
    // console.log(`prev${val}`);
  }
  handleNext(val: any) {
    // console.log(`next${val}`);
  }
  //   end 分页

  //start 弹框
  public addCarDialog = false;
  public searchPhoneNo = "";
  public roomIsShow = false;
  public addMoneyDialog = false;
  public detailDialog = false;
  public bjDialog = false;
  public payMoney = null;
  public tabName = "first";
  public userCurrentBalance = ""; //用户当前余额
  public userCzBalance = ""; //用户充值金额
  public maxRechargeAmount = ""; //最大可充值金额
  public UserCurrentId = ""; //当前用户id
  public xfInfo = [];
  public xftotal = 0;
  public xfParam = {
    pageIndex: 1,
    pageSize: 10,
    customerId: ""
  };
  public czInfo = [];
  public cztotal = 0;
  public czParam = {
    pageIndex: 1,
    pageSize: 10,
    customerId: ""
  };
  public form = {
    carNo: "",
    mobile: "",
    userName: "",
    maxRechargeAmount: "",
    userRechargeAmount: ""
  };
  public editForm = {
    carNo: "",
    mobile: "",
    userName: ""
  };
  //   后期添加
  //   public rules = {
  //     carNo: [{ required: true, message: "车牌不能为空", tigger: "blur" }],
  //     userName: [{ required: true, message: "用户名不能为空", tigger: "blur" }]
  //   };
  //   根据手机号查询是否存在
  searchPhone() {
    //   如果存在  就展示一般基本信息
    if (this.searchPhoneNo == "") {
      Message.warning("查询手机号不能为空");
      return;
    }
    this.roomIsShow = false;
    axios
      .get("customer", { params: { mobile: this.searchPhoneNo } })
      .then(res => {
        if (res.data.errCode == 0) {
          this.form = res.data.result;
          this.roomIsShow = true;
        } else {
          Message.warning(res.data.errMsg);
        }
      });
    // this.roomIsShow = true;
  }
  //添加车辆并且提交
  getCarInfo() {
    // console.log(this.form);
    let form = {
      carNo: this.form.carNo,
      mobile: this.form.mobile,
      userName: this.form.userName,
      maxRechargeAmount: this.form.userRechargeAmount
    };
    axios.post("customer", form).then(res => {
      if (res.data.errCode == 0) {
        this.addCarDialog = false;
        this.getListData();
      } else {
        Message.warning(res.data.errMsg);
      }
    });
  }

  //   充值方法
  czFunc(val: any) {
    // console.log(val);
    axios
      .post("customerbalance", {}, { params: { customerId: val } })
      .then(res => {
        if (res.data.errCode == 0) {
        //   console.log(res.data.result);
          this.userCurrentBalance = res.data.result.currentBalance;
          this.maxRechargeAmount = res.data.result.maxRechargeAmount;
          this.UserCurrentId = res.data.result.customerId;
        }
      });
  }
  //   确认充值
  OkCzFunc() {
    let param = {
      customerId: this.UserCurrentId,
      rechargeAmount: this.userCzBalance
    };
    axios.post("recharge", {}, { params: param }).then(res => {
      if (res.data.errCode == 0) {
        this.addMoneyDialog = false;
      } else {
        Message.warning(res.data.errMsg);
      }
      this.userCzBalance = "";
    });
  }
  //   查看详情
  getDetail(val: any) {
    // console.log(val);
    // 获取查看
    this.czParam.customerId = val;
    this.xfParam.customerId = val;
    this.UserCurrentId = val;
    this.getRechargelist();
  }
  getRechargelist() {
    axios.get("rechargelist", { params: this.czParam }).then(res => {
      if (res.data.errCode == 0) {
        this.czInfo = res.data.result;
        this.cztotal = res.data.totalCount;
      }
    });
  }
  czCurrent(val: any) {
    // console.log(val);
    this.czParam.pageIndex = val;
    this.getRechargelist();
  }
  xfCurrent(val: any) {
    // console.log(val);
    this.xfParam.pageIndex = val;
    this.getChargelist();
  }
  getChargelist() {
    axios.get("chargelist", { params: this.xfParam }).then(res => {
      if (res.data.errCode == 0) {
        this.xfInfo = res.data.result;
        this.xftotal = res.data.totalCount;
      }
    });
  }
  //   删除车辆
  carDetele() {
    MessageBox.confirm("此操作将永久删除该车辆信息, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
      callback: res => {
        // console.log(res);
        if (res == "confirm") {
          axios
            .post(
              "delcustomer",
              {},
              { params: { customerId: this.UserCurrentId } }
            )
            .then(res => {
              if (res.data.errCode == 0) {
                Message.success(res.data.errMsg);
                this.getListData();
                this.detailDialog = false;
              }
            });
        }
      }
    });
  }
  tabClick(tab: any, event: any) {
    // console.log(tab.index, event);
    if (tab.index == "0") {
      this.getRechargelist();
    } else {
      this.getChargelist();
    }
  }
  editUser() {
      axios.post('editcustomer',this.editForm).then(res=>{
          if(res.data.errCode==0){
              Message.success(res.data.errMsg);
              this.bjDialog=false;
              this.getListData();
          }
      })
  }
  bjUserInfo() {
    axios
      .get("customerinfo", { params: { customerId: this.UserCurrentId } })
      .then(res => {
        if (res.data.errCode == 0) {
            this.editForm=res.data.result;
        }
      });
  }
  // end 弹框
}
